<template>
  <div id="app">
    <Configurator></Configurator>
  </div>
</template>
<script>
    import '@/assets/scss/configurator.scss';
    // import '@/assets/scss/innobun.scss';


    const Configurator = () => import('@/views/Configurator');

    export default {
        components: {Configurator}
    }
</script>

<style lang="scss">

</style>